import { render, staticRenderFns } from "./balancesetPage.vue?vue&type=template&id=b9abf3b4&scoped=true"
import script from "./balancesetPage.vue?vue&type=script&lang=js"
export * from "./balancesetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9abf3b4",
  null
  
)

export default component.exports